import { useEffect, useState } from 'react'

function useMobileView(threshold = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= threshold)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= threshold)
        }

        window.addEventListener('resize', handleResize)

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [threshold])

    return isMobile
}

export default useMobileView